
import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { createTicketRequest, getDepartmentsRequest, getTicketAttachmentRequest, getTicketRequest, getTicketsRequest, postTicketAPIRunnerRequest, replayTicketRequest } from '../apiRequests/supportRequest'


function* handleGetDepartmentsRequest(action) {
    try {
        const response = yield call(getDepartmentsRequest, action.params)

        yield put({
            type: types.GET_DEPARTMENTS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_DEPARTMENTS_ERROR,
            error: error.response,
        })
    }
}



function* handleCreateTicketRequest(action) {
    try {
        const response = yield call(createTicketRequest, action.params)

        yield put({
            type: types.CREATE_TICKET_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.CREATE_TICKET_ERROR,
            error: error.response,
        })
    }
}


function* handleGetTicketsRequest(action) {
    try {
        const response = yield call(getTicketsRequest, action.params)

        yield put({
            type: types.GET_TICKETS_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.GET_TICKETS_ERROR,
            error: error.response,
        })
    }
}


function* handleReplayTicketRequest(action) {
    try {
        const response = yield call(replayTicketRequest, action.params)

        yield put({
            type: types.REPLAY_TICKET_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.REPLAY_TICKET_ERROR,
            error: error.response,
        })
    }
}


function* handleGetTicketRequest(action) {
    try {
        const response = yield call(getTicketRequest, action.params)

        yield put({
            type: types.GET_TICKET_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.GET_TICKET_ERROR,
            error: error.response,
        })
    }
}


function* handleGetTicketAttachmentRequest(action) {
    try {
        const response = yield call(getTicketAttachmentRequest, action.params)

        yield put({
            type: types.GET_TICKET_ATTACHMENT_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.GET_TICKET_ATTACHMENT_ERROR,
            error: error.response,
        })
    }
}


function* handlePostTicketAPIRunnerRequest(action) {
    try {
        const response = yield call(postTicketAPIRunnerRequest, action.params)

        yield put({
            type: types.POST_TICKET_API_RUNNER_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.POST_TICKET_API_RUNNER_ERROR,
            error: error.response,
        })
    }
}

function* watcherSupportSaga() {
    yield takeEvery(types.GET_DEPARTMENTS_REQUEST, handleGetDepartmentsRequest)
    yield takeEvery(types.CREATE_TICKET_REQUEST, handleCreateTicketRequest)
    yield takeEvery(types.GET_TICKETS_REQUEST, handleGetTicketsRequest)
    yield takeEvery(types.REPLAY_TICKET_REQUEST, handleReplayTicketRequest)
    yield takeEvery(types.GET_TICKET_REQUEST, handleGetTicketRequest)
    yield takeEvery(types.GET_TICKET_ATTACHMENT_REQUEST, handleGetTicketAttachmentRequest)
    yield takeEvery(types.POST_TICKET_API_RUNNER_REQUEST, handlePostTicketAPIRunnerRequest)








}

export default watcherSupportSaga